export enum BackupLicenseStatuses {
  Assigned = 'Assigned',
  NotAvailable = 'Not Available',
  Inactive = 'Inactive'
}
